(function () {
  var copyBtn = document.querySelector('[data-aty-copy]');
  if (!copyBtn) return;
  var codeEl = document.querySelector('[data-aty-code]');
  var defaultLabel = copyBtn.innerHTML;

  copyBtn.addEventListener('click', function () {
    var text = codeEl ? codeEl.textContent.trim() : '';
    if (!text) return;

    var done = function () {
      copyBtn.classList.add('is-copied');
      copyBtn.innerHTML = copyBtn.getAttribute('data-copied-label') || 'คัดลอกแล้ว ✓';
      setTimeout(function () {
        copyBtn.classList.remove('is-copied');
        copyBtn.innerHTML = defaultLabel;
      }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(done);
    } else {
      var tmp = document.createElement('textarea');
      tmp.value = text;
      tmp.style.position = 'fixed';
      tmp.style.opacity = '0';
      document.body.appendChild(tmp);
      tmp.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(tmp);
      done();
    }
  });
})();

(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var colors = ['#7d908a', '#b3c3af', '#d7a89c', '#e2c6be', '#3a3a39'];
  var count = window.innerWidth < 560 ? 70 : 130;

  var canvas = document.createElement('canvas');
  canvas.style.position = 'fixed';
  canvas.style.inset = '0';
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = '9999';
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var dpr = window.devicePixelRatio || 1;

  function resize() {
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();

  var pieces = [];
  for (var i = 0; i < count; i++) {
    pieces.push({
      x: Math.random() * window.innerWidth,
      y: -20 - Math.random() * window.innerHeight * 0.5,
      w: 6 + Math.random() * 5,
      h: 9 + Math.random() * 6,
      color: colors[Math.floor(Math.random() * colors.length)],
      rot: Math.random() * 360,
      rotSpeed: (Math.random() - 0.5) * 10,
      vy: 2.2 + Math.random() * 2.4,
      vx: (Math.random() - 0.5) * 1.6,
      drift: Math.random() * Math.PI * 2
    });
  }

  var start = null;
  var duration = 3400;
  var rafId;

  function frame(ts) {
    if (!start) start = ts;
    var elapsed = ts - start;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    pieces.forEach(function (p) {
      p.y += p.vy;
      p.x += p.vx + Math.sin((elapsed / 400) + p.drift) * 0.6;
      p.rot += p.rotSpeed;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rot * Math.PI) / 180);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    });

    if (elapsed < duration) {
      rafId = requestAnimationFrame(frame);
    } else {
      cancelAnimationFrame(rafId);
      canvas.remove();
    }
  }

  window.addEventListener('resize', resize, { passive: true });
  rafId = requestAnimationFrame(frame);
})();

(function () {
  var openBtns = document.querySelectorAll('[data-aty-howto-open]');
  var modal = document.getElementById('atyHowtoModal');
  if (!openBtns.length || !modal) return;
  var closeBtn = modal.querySelector('[data-aty-howto-close]');

  function open() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden && (!lightbox || lightbox.hidden)) close();
  });

  var zoomBtns = document.querySelectorAll('[data-aty-zoom]');
  var lightbox = document.getElementById('atyLightbox');
  var lightboxImg = document.getElementById('atyLightboxImg');
  var lightboxClose = document.getElementById('atyLightboxClose');
  if (!zoomBtns.length || !lightbox || !lightboxImg) return;

  function openLightbox(src, alt) {
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
  }
  function closeLightbox() {
    lightbox.hidden = true;
    lightboxImg.src = '';
  }

  zoomBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var img = btn.parentElement.querySelector('img');
      if (img) openLightbox(img.src, img.alt);
    });
  });
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
  });
})();
